import { Loader } from 'component/customComponents/loader/loader';
import React, { ReactElement, Suspense, lazy, memo } from 'react';

const LazyNewLessonViewer = lazy(() =>
  import('./newLessonViewer')
    .then((module) => ({ default: module.NewLessonViewer }))
    .catch(() => {
      document.location.reload();
      return { default: memo(() => <></>) };
    })
);

export const NewLessonViewer = (): ReactElement => (
  <Suspense fallback={<Loader />}>
    <LazyNewLessonViewer />
  </Suspense>
);
